import { render, staticRenderFns } from "./UserArticlesList.vue?vue&type=template&id=826fd41a&"
import script from "./UserArticlesList.vue?vue&type=script&lang=js&"
export * from "./UserArticlesList.vue?vue&type=script&lang=js&"
import style0 from "./UserArticlesList.vue?vue&type=style&index=0&id=826fd41a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports